@let userLoggedIn = (_authService.uid$ | async); 
@let currentUser = (_authService.userProfile$ | async); 
@if (layout()=='sidebar'){
    <div class="sidebar">
        <a class="navbar-brand" [routerLink]="['/']">Civil Discourse</a>
        <nav class="nav flex-column">
            <ng-container *ngTemplateOutlet="menu"></ng-container>
            <hr>
            <ng-container *ngTemplateOutlet="authstate"></ng-container>
            <hr>
        </nav>
    </div>
} @else {

<nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a class="navbar-brand">Civil Discourse {{layout()}}</a>
      <button class="navbar-toggler" type="button" (click)="open(content)" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
        <div class="navbar-nav">
          <ng-container *ngTemplateOutlet="menu"></ng-container>
          <hr>
          <ng-container *ngTemplateOutlet="authstate"></ng-container>
          <hr>
        </div>
      </div>
    </div>
</nav>

}

<ng-template #menu>
    @for (item of items; track item.id) {
        <a id="site-nav-{{item.id}}" 
            class="nav-link"
            [ngClass]="{active:isActive(item)|async}"  
            [routerLink]="item.route"
            >
            @if (item.iconClass) {
                <i class="{{item.iconClass}}"></i>
            }
        {{item.label}}
    </a>
    }
</ng-template>
<ng-template #authstate>
    @if (userLoggedIn){
        @if (currentUser) {
            <a class="nav-link" [routerLink]="['/profile']">
                @if (currentUser['imageUrl']) {
                    <img [src]="userImage($any(currentUser['imageUrl']))" style="height:1lh"> 
                } @else {
                    <img src="/assets/user-circle.svg" style="height:1lh"> 
                }
                Profile
            </a>
            <a (click)="_authService.logout()" class="nav-link">
                <i class="fa-solid fa-right-to-bracket"></i> Sign Out
            </a>
        } 
    } @else {
        <a [routerLink]="['/auth']" class="nav-link">
            <i class="fa-solid fa-right-to-bracket"></i> Sign In
        </a>
    }
</ng-template>
<ng-template #content let-offcanvas>
	<div class="offcanvas-header">
        <a class="navbar-brand" [routerLink]="['/']" (click)="offcanvas.dismiss('New Section')">Civil Discourse</a>
		<button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body" (click)="offcanvas.dismiss('New Section')">
        <div class="sidebar">
            <nav class="nav flex-column">
                <ng-container *ngTemplateOutlet="menu"></ng-container>
                <hr>
                <ng-container *ngTemplateOutlet="authstate"></ng-container>
                <hr>
            </nav>
        </div>
    </div>
</ng-template>